export default {
  'register-invoiced': 'Register billing information',
  'assign-products': 'Assign inspector',
  'edit-service': 'Edit service'
};
